import { render } from "./Facture.vue?vue&type=template&id=3273df16&scoped=true"
import script from "./Facture.vue?vue&type=script&lang=js"
export * from "./Facture.vue?vue&type=script&lang=js"

import "./Facture.vue?vue&type=style&index=0&id=3273df16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3273df16"]])

export default __exports__